import { ReferenceItem, ReferenceValue } from '../../../../../../types/types';

interface GetSelectedItemsFromValueOptions {
  value: ReferenceValue;
  data: any[];
  idItem: string;
  labelItem: string;
  isMultiselect?: boolean;
  delimiter?: string;
  formatLabel?: (value: string) => string;
}

// Splits a delimited value string and maps each ID to a ReferenceItem
// by looking it up in the loaded data rows. Unmatched IDs are silently skipped.
export const getSelectedItemsFromValue = ({
  value,
  data,
  idItem,
  labelItem,
  isMultiselect = true,
  delimiter = ',',
  formatLabel = (label) => label,
}: GetSelectedItemsFromValueOptions): ReferenceItem[] => {
  // value arrives as a number for integer reference fields; normalize before comparing to stringified ids.
  const stringValue = String(value);
  const splittedValue = isMultiselect
    ? stringValue.split(delimiter)
    : [stringValue];
  const newSelectedItems: ReferenceItem[] = [];
  splittedValue.forEach((v) => {
    const foundItem = data.find((item) => item[idItem].toString() === v);
    if (foundItem) {
      newSelectedItems.push({
        value: foundItem[idItem].toString(),
        label: formatLabel(String(foundItem[labelItem])),
      });
    }
  });
  return newSelectedItems;
};
